import { render, staticRenderFns } from "./ShopPreview.vue?vue&type=template&id=25afefda&scoped=true&"
import script from "./ShopPreview.vue?vue&type=script&lang=js&"
export * from "./ShopPreview.vue?vue&type=script&lang=js&"
import style0 from "./ShopPreview.vue?vue&type=style&index=0&id=25afefda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25afefda",
  null
  
)

export default component.exports